import { Routes } from '@angular/router';
import { HomeComponent } from './features/home/home.component';
import { AccessDeniedComponent } from './features/access-denied/access-denied.component';
import { ErrorComponent } from './features/error.component/error.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'roles',
    loadChildren: () => import('./features/roles/roles.routes'),
  },
  {
    path: 'usuario-roles',
    loadChildren: () => import('./features/usuario-roles/usuario-roles.routes'),
  },
  {
    path: 'legajos',
    loadChildren: () => import('./features/legajos/legajos.routes'),
  },
  {
    path: 'usuario-planta',
    loadChildren: () => import('./features/usuario-planta/usuario-planta.routes'),
  },
  {
    path: 'error',
    component: ErrorComponent,
  },
  {
    path: 'denegado',
    component: AccessDeniedComponent
  },
  {
    path: '**',
    redirectTo: ''
  }
];
